(() => {
  class e extends HTMLElement {
    constructor() {
      super(),
        (this.loader = document.querySelector(".loader-container")),
        (this.sectionId = this.getAttribute("data-section-id")),
        (this.parentSelector = this.getAttribute("data-parent-element")),
        (this.parentNodeEl = this.parentElement),
        (this.desiredOrder = this.dataset.order);
    }
    connectedCallback() {
      let e = this;
      this.loader.classList.add("hide"),
        this.loader.classList.remove("show"),
        this.handleOrderBy(),
        this.handlePagination(),
        this.handleGridView(),
        this.querySelectorAll(".close-filters-js").forEach((t) => {
          t.addEventListener("click", (t) => {
            t.preventDefault(),
              (e.closest(".filters-wrapper").style.display = "none");
          });
        }),
        document.querySelectorAll(".open-filters-js").forEach((e) => {
          e.addEventListener("click", (e) => {
            e.preventDefault(),
              (document.querySelector(".filters-wrapper").style.display =
                "block");
          });
        }),
        this.querySelectorAll(".active-filters-header__remove-all").forEach(
          (t) => {
            t.addEventListener("click", (r) => {
              r.preventDefault();
              const s = t.getAttribute("data-href");
              e.updateCollectionTemplate(s);
            });
          }
        ),
        this.querySelectorAll(".active-filters__remove-filter").forEach((t) => {
          t.addEventListener("click", (r) => {
            r.preventDefault();
            let s = new URLSearchParams("");
            const o = new URL(window.location.href),
              a = new URLSearchParams(o.search);
            if ((console.log("current", a), t.getAttribute("data-href"))) {
              let e = t.getAttribute("data-href");
              s = new URLSearchParams(e);
            }
            a.has("q") && (s.set("q", a.get("q")), console.log("tiene"));
            const i = s.toString();
            e.updateCollectionTemplate(i);
          });
        }),
        this.querySelectorAll(".filter-group-header").forEach((e) => {
          e.addEventListener("click", () => {
            const t = e.parentElement,
              r = t.querySelector(".filter-group-display");
            r.classList.contains("open")
              ? (r.classList.remove("open"),
                t.classList.remove("open"),
                t
                  .querySelector(".filter-group-summary")
                  .classList.add("toggle-open"))
              : (r.classList.add("open"),
                t.classList.add("open"),
                t
                  .querySelector(".filter-group-summary")
                  .classList.remove("toggle-open"));
          });
        }),
        this.querySelectorAll(
          '.filter-group-display__list input[type="checkbox"], .filter-group-display__price-range input[type="number"]'
        ).forEach((t) => {
          t.addEventListener("change", function (t) {
            t.preventDefault();
            const r = t.target.closest("form"),
              s = new FormData(r);
            let o = new URLSearchParams(s);
            const a = new URL(window.location.href),
              i = new URLSearchParams(a.search);
            i.has("sort_by") && o.set("sort_by", i.get("sort_by")),
              i.has("q") && o.set("q", i.get("q"));
            const l = o.toString();
            e.updateCollectionTemplate(l);
          });
        });
    }
    handlePagination() {
      const e = this;
      document.querySelectorAll(".next-cta").forEach((t) => {
        console.log(t),
          t.addEventListener("click", (r) => {
            r.preventDefault();
            const s = t.getAttribute("data-next-page"),
              o = new URL(window.location.href),
              a = new URLSearchParams(o.search);
            a.set("page", s),
              e.setPagination(a.toString()),
              document.querySelectorAll(".next-cta")[0].parentElement.remove();
          });
      });
    }
    setPagination(e) {
      this.loader.classList.add("show"), this.loader.classList.remove("hide");
      const t = `${window.location.pathname}?${e}`;
      history.pushState(null, "", t),
        fetch(`${window.location.pathname}?section_id=${this.sectionId}&${e}`, {
          method: "GET",
        })
          .then((e) => e.text())
          .then((e) => {
            this.loader.classList.remove("show"),
              this.loader.classList.add("hide");
            const t = new DOMParser().parseFromString(e, "text/html");
            t.querySelector(".previous-cta").parentElement.remove();
            const r = t.querySelector(".products-wrapper").innerHTML;
            (document.querySelector(".products-wrapper").innerHTML += r),
              this.handlePagination(),
              this.handleGridView(),
              yotpo.initWidgets();
            window.dispatchEvent(
              new CustomEvent("plp:collection:rendered", {
                detail: { type: "append", sectionId: this.sectionId },
              })
            );
          })
          .catch((e) => {
            this.loader.classList.remove("show"),
              this.loader.classList.add("hide"),
              console.error("Error updating collection template:", e);
          });
    }
    handleGridView() {
      const e = document.querySelectorAll(".product-grid");
      e.forEach((e) => {
        const t = document.querySelector(".show-toggle.active");
        if (t) {
          const r = t.getAttribute("data-grid");
          e.classList.remove("grid-2"),
            e.classList.remove("grid-3"),
            e.classList.add(`grid-${r}`);
        }
      }),
        Array.from(
          document.querySelector(".show-toggles__wrap")?.children || ""
        ).forEach((t) => {
          console.log("este", t),
            t.addEventListener("click", () => {
              console.log("click");
              const r = t.getAttribute("data-grid"),
                s = document.querySelector(".show-toggle.active");
              console.log(s, r),
                s.classList.remove("active"),
                t.classList.add("active"),
                e.forEach((e) => {
                  e.classList.remove("grid-2"),
                    e.classList.remove("grid-3"),
                    e.classList.add(`grid-${r}`);
                });
            });
        });
    }
    handleOrderBy() {
      const e = this,
        t = document.querySelector(".select-form");
      t &&
        t.addEventListener("change", function (t) {
          t.preventDefault();
          const r = new URL(window.location.href),
            s = new URLSearchParams(r.search),
            o = new URL(window.location.href),
            a = new URLSearchParams(o.search),
            i = t.target.value;
          s.set("sort_by", i),
            a.has("q") && s.set("q", a.get("q")),
            (r.search = s.toString()),
            e.updateCollectionTemplate(r.search.replace("?", "").trim());
        });
    }
    updateCollectionTemplate(e) {
      let t;
      (e || "" == e) && (t = e),
        this.loader.classList.add("show"),
        this.loader.classList.remove("hide");
      const r = `${window.location.pathname}?${t}`;
      history.pushState(null, "", r),
        fetch(`${window.location.pathname}?section_id=${this.sectionId}&${t}`, {
          method: "GET",
        })
          .then((e) => e.text())
          .then((e) => {
            this.loader.classList.remove("show"),
              this.loader.classList.add("hide");
            const t = new DOMParser()
              .parseFromString(e, "text/html")
              .querySelector(this.parentSelector).innerHTML;
            (document.querySelector(this.parentSelector).innerHTML = t),
              this.handleGridView(),
              this.reorderFilterItems();
            window.dispatchEvent(
              new CustomEvent("plp:collection:rendered", {
                detail: { type: "replace", sectionId: this.sectionId },
              })
            );
          })
          .catch((e) => {
            this.loader.classList.remove("show"),
              this.loader.classList.add("hide"),
              console.error("Error updating collection template:", e);
          });
    }
    reorderFilterItems() {
      const e = this.desiredOrder.split(","),
        t = document.querySelector(".filter-group-display__list"),
        r = Array.from(t.querySelectorAll(".filter-group-display__list-item"));
      r.sort((t, r) => {
        const s = t.querySelector("input").value,
          o = r.querySelector("input").value;
        return e.indexOf(s) - e.indexOf(o);
      }),
        (t.innerHTML = ""),
        r.forEach((e) => t.appendChild(e));
      const s = document.querySelector(
          ".filter-group-display__list.list-stones"
        ),
        o = Array.from(s.children).find((e) =>
          e.querySelector("input").value.includes("Sapphires")
        );
      o && s.append(o);
    }
  }
  document.addEventListener("DOMContentLoaded", () => {
    customElements.define("filter-form-component", e);
  });
})();
